import mutations from './drugEquiv.mutations'
import actions from './drugEquiv.actions'
import getters from './drugEquiv.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
